module.exports = __webpack_public_path__ + "static/media/windsock.246c2b44.svg";